import Vue from 'vue'
import Router from 'vue-router'
import { routers } from './routes'
import store from '../store'

Vue.use(Router)

const RouterConfig = {
  // mode: 'history',
  routes: routers
}

export const router = new Router(RouterConfig)

const limitRouterNames = ['answer_detail', 'edit_answer']

router.beforeEach((to, from, next) => {
  if (process.env.NODE_ENV === 'testing') {
    next()
    return
  }
  let noLoginPath = ['/forgetPwd', '/setNickName', '/login', '/login/f', '/token', '/organizeLogin', '/orgApply', '/register']
  if (noLoginPath.indexOf(to.path) !== -1) {
    next()
  } else {
    // 先判断store中有没有用户信息
    if (store.state.app.userInfo.uuid) {
      next()
    } else {
      // 判断sessionStorage 里面是否有userInfo
      // sessionStorage.userInfo = '{"id":55,"uuid":"4AD1E6E3FB0E480296DDDC429A23B4F0","type":2,"expertType":1,"nickName":"test","photo":"https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKBFqLBrUU5cAxWJ6OfaIqn8dq6GRST1EUGibyPDAusGUVwb7spE6E3AIvoWsu3toZUuSxDibdn1omw/132","expertCompany":"打粉底安抚","expertPost":"范德萨阿范德萨f\'d","applyExpertStatus":2,"isPublish":1,"forbiddenDayNum":null,"questionNum":20,"questionFollowNum":10,"fansNum":0,"newFansNum":0,"expertFollowNum":10,"lastLoginTime":"2018-08-23 09:14","createTime":"2018-07-10 10:40","expertId":"55","expertName":"test","expertPhoto":"https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKBFqLBrUU5cAxWJ6OfaIqn8dq6GRST1EUGibyPDAusGUVwb7spE6E3AIvoWsu3toZUuSxDibdn1omw/132","expertDetail":"粉底阿凡达阿凡达阿凡达阿凡达的发大水发","expertLabelIdList":"1","expertLabelNameList":"基金","expertReasonDuration":"10396244","expertLabelName":null,"expertReasonNum":null,"isCollectExpert":0}'
      let userInfo = window.sessionStorage['userInfo']
      if (userInfo) {
        store.dispatch('getUserInfo')
        store.commit('initUserInfo', JSON.parse(userInfo))
        if (limitRouterNames.indexOf(to.name) > -1) {
          next({
            path: '/wait'
          })
        } else {
          next()
        }
      } else {
        next({
          path: '/login'
        })
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js